module.exports = __webpack_public_path__ + "img/bg_products.30c5928a.png";